import { render, staticRenderFns } from "./ShareModal.vue?vue&type=template&id=156554fe&"
import script from "./ShareModal.controller.js?vue&type=script&lang=js&"
export * from "./ShareModal.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ShareModal.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "07bce0b4"
  
)

export default component.exports